(function() {

	angular
		.module('ngmvac')
		.filter('municipalitysFilter', MunicipalitysFilter);

	function MunicipalitysFilter() {
		return function(arr,value) {
		
            var municipalitysArray = [];
             if(value){
                   angular.forEach(arr,function(municipality) {
                        if(municipality.state_id == value){
                            municipalitysArray.push(municipality);
                        }
                    });
             }
            return municipalitysArray;
		} 
	}

})();